// Chart.js - MCadEx-frontend
import React, { PureComponent } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import moment from 'moment';
import { useState } from 'react';
import Collapse from 'react-bootstrap/Collapse';


var data = [];

var i_factor = 0.001;
var u_factor = 0.001;

// Tooltipin muotoilu
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length > 1) {
    //console.log('tooltip', 'label:', label, 'payload:', payload, )
    let time = moment.unix(label).format('D.M.YYYY HH:mm:ss');
    return (
      <div className="custom-tooltip">
        <p className="label" style={{color: '#000000' }}>{`${time}`}</p>
        {/*
        <p className="label" style={{color: payload[0].color }}>{`${payload[0].name} ${payload[0].value.toFixed(1)}A`}</p>
        <p className="label" style={{color: payload[1].color }}>{`${payload[1].name} ${payload[1].value.toFixed(1)}V`}</p>
        */}
        <p className="label" style={{color: payload[0].color}}>{`Virta ${payload[0].value.toFixed(2)}A`}</p>
        <p className="label" style={{color: payload[1].color }}>{`Jännite ${payload[1].value.toFixed(2)}V`}</p>
      </div>
    );
  }

  return null;
};

// Akselin väliotsikot
class CustomizedAxisTick extends PureComponent {
  render() {
    const { x, y, stroke, payload } = this.props;

    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-5)">
          {payload.value.toFixed(0) + " test"}
        </text>
      </g>
    );
  }
}

// <Chart key={name} configuration={configuration} measurements={measurements}>Heippa</Chart>
// Huom! measurementsissa tulee measurements, eikä all_measurements
//const Chart = ({name, configuration, history}) => {
const Chart = ({name, device, history}) => {
  //console.log('chart1', name, device, '=>', history)
    
    if (history === '{}' || history === null)
      return (<></>);


    //console.log('chart2', name, device, '=>', history)

    //let currentConfig = config.find(x => x.site === name);
    //console.log('testifind', currentConfig)
    //console.log('history.length',history.length)
    let parsedHistoryJson = JSON.parse(history);
    if (parsedHistoryJson === undefined) return;
    let deviceData = parsedHistoryJson[name];
    if (deviceData === undefined) return;

    //if (history.length < 10)
    //  console.log('ainoastaan 10 pitkä')
    let historyAsObject = JSON.parse(history)[name][device];//["C8:F0:9E:52:3B:70"];
    if (historyAsObject === undefined) return;

    let min = 0;
    let max = 0;
    
    let ioutArray = historyAsObject.map(x => x['iout']);
    let uoutArray = historyAsObject.map(x => x['uout']);

    let ioutMin = Math.trunc( Math.min(...ioutArray) );
    let ioutMax =  Math.trunc( Math.max(...ioutArray) );
    let uoutMin =  Math.trunc( Math.min(...uoutArray) );
    let uoutMax =  Math.trunc( Math.max(...uoutArray) );

    ioutMin = (ioutMin - 1 < 0) ? 0 : ioutMin - 1;
    ioutMax = ioutMax + 2;
    uoutMin = (uoutMin - 1 < 0) ? 0 : uoutMin - 1;
    uoutMax = uoutMax + 2;

    var loppuaika = moment().subtract(2, 'month');
    //console.log('loppuaika', loppuaika)

    return (
        <>
          <ResponsiveContainer width = '99%' height = {400}>
            <LineChart width={600} height={300} data={historyAsObject}>


                <CartesianGrid strokeDasharray="3 3" stroke="#ccc" fill='#f8f8f8' />

                <XAxis
                  dataKey="timestamp"
                  domain = {['dataMin', 'dataMax']}
                  name = 'timestamp'
                  stroke = '#f8f8f8'
                  tickFormatter = {(unixTime) => {
                    var muokattuAika = moment.unix(unixTime).format('DD-MM-YYYY')
                    return muokattuAika
                    }
                  } 
                  tickCount={15}
                  //scale="time"
                  type="number" 
                />
                
                <YAxis yAxisId="iout" dataKey="iout" type="number" unit="A" domain = {[ioutMin, ioutMax]} stroke="#f8f8f8" tickFormatter = {(x) => { return x.toFixed(1) }} label={{ value: "I", dx: -15, stroke:"#f8f8f8"}} />
                <YAxis yAxisId="uout" dataKey="uout" type="number" unit="V" domain = {[uoutMin, uoutMax]} stroke="#f8f8f8" tickFormatter = {(x) => { return x.toFixed(1)}} label={{ value: "U", dx: -15, stroke:"#f8f8f8"}} />

                <Line type="monotone" yAxisId="iout" dataKey="iout" stroke="#fc3f05" name="Virta" strokeWidth={1} dot={false} isAnimationActive={false} />
                <Line type="monotone" yAxisId="uout" dataKey="uout" stroke="#8884d8" name="Jännite" strokeWidth={1} dot={false} isAnimationActive={false} />

                <Tooltip content={<CustomTooltip />} />
                <Legend formatter={(value) => value.charAt(0).toUpperCase() + value.slice(1)} verticalAlign="bottom" height={36} />
            </LineChart>
          </ResponsiveContainer>
        </>
    )
  };

  export default Chart